import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BulkOrderForm from './BulkOrderForm'; 

const Contact = () => {
    // 1. Define State for Form Data
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const colors = {
        deepBlue: '#1A3C8F',
        blue: '#185FA5',
        lightBlue: '#378ADD',
        orange: '#F57C00',
        green: '#4CAF50',
        lightBg: 'linear-gradient(135deg, #FDF6EE 0%, #FAECE7 100%)',
        white: '#ffffff',
    };

    // 2. Handle Input Changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    // 3. Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const apiUrl = process.env.REACT_APP_API_URL;

        try {
            const response = await fetch(`${apiUrl}/contact/submit`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            const result = await response.json();
            if (result.success) {
                alert("Sent Successfully!");
                setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
            } else {
                alert("Submission failed. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while sending the message.");
        }
    };

    return (
        <>
            {/* ───────────────────────────────────────────
                Section 1 : Contact Form + Info Sidebar
            _______________________________________________ */}
            <section className="contact py-80">
                <div className="container container-lg">
                    <div className="row gy-5">

                        {/* Contact Form Section */}
                        <div className="col-lg-8">
                            <div
                                className="contact-box rounded-16 px-24 py-40 bg-white"
                                style={{
                                    border: `1.5px solid #B5D4F4`,
                                    boxShadow: '0 4px 24px rgba(26,60,143,0.08)',
                                }}
                            >
                                <form onSubmit={handleSubmit}>
                                    <h6 className="mb-32" style={{ color: colors.deepBlue, fontWeight: 700 }}>
                                        Make Custom Request
                                    </h6>
                                    <div className="row gy-4">
                                        <div className="col-sm-6 col-xs-6">
                                            <label htmlFor="name" className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                                                Full Name <span style={{ color: colors.orange }} className="text-xl line-height-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="common-input px-16"
                                                id="name"
                                                placeholder="Full name"
                                                required
                                                value={formData.name}
                                                onChange={handleChange}
                                                style={{ borderColor: '#B5D4F4' }}
                                                onFocus={(e) => e.target.style.borderColor = colors.lightBlue}
                                                onBlur={(e) => e.target.style.borderColor = '#B5D4F4'}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-xs-6">
                                            <label htmlFor="email" className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                                                Email Address <span style={{ color: colors.orange }} className="text-xl line-height-1">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                className="common-input px-16"
                                                id="email"
                                                placeholder="Email address"
                                                required
                                                value={formData.email}
                                                onChange={handleChange}
                                                style={{ borderColor: '#B5D4F4' }}
                                                onFocus={(e) => e.target.style.borderColor = colors.lightBlue}
                                                onBlur={(e) => e.target.style.borderColor = '#B5D4F4'}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-xs-6">
                                            <label htmlFor="phone" className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                                                Phone Number <span style={{ color: colors.orange }} className="text-xl line-height-1">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                className="common-input px-16"
                                                id="phone"
                                                placeholder="Phone Number*"
                                                required
                                                value={formData.phone}
                                                onChange={handleChange}
                                                style={{ borderColor: '#B5D4F4' }}
                                                onFocus={(e) => e.target.style.borderColor = colors.lightBlue}
                                                onBlur={(e) => e.target.style.borderColor = '#B5D4F4'}
                                            />
                                        </div>
                                        <div className="col-sm-6 col-xs-6">
                                            <label htmlFor="subject" className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                                                Subject <span style={{ color: colors.orange }} className="text-xl line-height-1">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="common-input px-16"
                                                id="subject"
                                                placeholder="Subject"
                                                required
                                                value={formData.subject}
                                                onChange={handleChange}
                                                style={{ borderColor: '#B5D4F4' }}
                                                onFocus={(e) => e.target.style.borderColor = colors.lightBlue}
                                                onBlur={(e) => e.target.style.borderColor = '#B5D4F4'}
                                            />
                                        </div>
                                        <div className="col-sm-12">
                                            <label htmlFor="message" className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4">
                                                Message <span style={{ color: colors.orange }} className="text-xl line-height-1">*</span>
                                            </label>
                                            <textarea
                                                className="common-input px-16"
                                                id="message"
                                                placeholder="Type your message"
                                                required
                                                value={formData.message}
                                                onChange={handleChange}
                                                style={{ borderColor: '#B5D4F4' }}
                                                onFocus={(e) => e.target.style.borderColor = colors.lightBlue}
                                                onBlur={(e) => e.target.style.borderColor = '#B5D4F4'}
                                            />
                                        </div>
                                        <div className="col-sm-12 mt-32">
                                            <button
                                                type="submit"
                                                className="btn py-18 px-32 rounded-8 text-white fw-bold transition-2"
                                                style={{ backgroundColor: colors.deepBlue, border: 'none' }}
                                                onMouseOver={(e) => e.target.style.backgroundColor = colors.orange}
                                                onMouseOut={(e) => e.target.style.backgroundColor = colors.deepBlue}
                                            >
                                                Get a Quote
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Contact Info Sidebar */}
                        <div className="col-lg-4">
                            <div
                                className="contact-box rounded-16 px-24 py-40 bg-white"
                                style={{
                                    border: `1.5px solid #B5D4F4`,
                                    boxShadow: '0 4px 24px rgba(26,60,143,0.08)',
                                }}
                            >
                                <h6 className="mb-48" style={{ color: colors.deepBlue, fontWeight: 700 }}>
                                    Get In Touch
                                </h6>

                                {/* Phone */}
                                <div className="flex-align gap-16 mb-16">
                                    <span
                                        className="w-40 h-40 flex-center rounded-circle text-2xl flex-shrink-0"
                                        style={{
                                            color: colors.white,
                                            backgroundColor: colors.deepBlue,
                                            border: `1.5px solid #B5D4F4`,
                                        }}
                                    >
                                        <i className="ph-fill ph-phone-call" />
                                    </span>
                                    <a href="tel:+918056364292" className="text-md text-gray-900" style={{ transition: '0.3s' }}>
                                        8056364292
                                    </a>
                                </div>

                                {/* Email */}
                                <div className="flex-align gap-16 mb-16">
                                    <span
                                        className="w-40 h-40 flex-center rounded-circle text-2xl flex-shrink-0"
                                        style={{
                                            color: colors.white,
                                            backgroundColor: colors.orange,
                                            border: `1.5px solid #FAC775`,
                                        }}
                                    >
                                        <i className="ph-fill ph-envelope" />
                                    </span>
                                    <a href="mailto:mamtha.panneer2014@gmail.com" className="text-md text-gray-900">
                                        mamtha.panneer2014@gmail.com
                                    </a>
                                </div>

                                {/* Address */}
                                <div className="flex-align gap-16 mb-0">
                                    <span
                                        className="w-40 h-40 flex-center rounded-circle text-2xl flex-shrink-0"
                                        style={{
                                            color: colors.white,
                                            backgroundColor: colors.green,
                                            border: `1.5px solid #C0DD97`,
                                        }}
                                    >
                                        <i className="ph-fill ph-map-pin" />
                                    </span>
                                    <span className="text-md text-gray-900">
                                        Plot No B4, C1, Karpagam Illam
                                        Sree Srinivasan Nagar Extension
                                        Thandalam Road, Kovur,
                                        Kancheepuram District,
                                        Chennai- 600128
                                    </span>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="mt-24 d-flex flex-column gap-16">
                                <Link
                                    to="#"
                                    className="rounded-8 p-10 px-16 d-flex justify-content-between align-items-center flex-wrap gap-8 transition-2"
                                    style={{ backgroundColor: colors.deepBlue }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = colors.lightBlue}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = colors.deepBlue}
                                >
                                    <span className="text-white fw-medium">Get Support On Call</span>
                                    <span
                                        className="w-36 h-36 bg-white rounded-8 flex-center text-xl"
                                        style={{ color: colors.deepBlue }}
                                    >
                                        <i className="ph ph-headset" />
                                    </span>
                                </Link>

                                <Link
                                    to="#"
                                    className="rounded-8 p-10 px-16 d-flex justify-content-between align-items-center flex-wrap gap-8 transition-2"
                                    style={{ backgroundColor: colors.green }}
                                    onMouseOver={(e) => e.currentTarget.style.opacity = '0.9'}
                                    onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
                                >
                                    <span className="text-white fw-medium">Get Direction</span>
                                    <span
                                        className="w-36 h-36 bg-white rounded-8 flex-center text-xl"
                                        style={{ color: colors.green }}
                                    >
                                        <i className="ph ph-map-pin" />
                                    </span>
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ───────────────────────────────────────────
                Section 2 : Bulk Order Form (கீழே)
            _______________________________________________ */}
            <div style={{
                borderTop: '2px dashed #B5D4F4',
                margin: '0 0 0 0',
            }} />

            <BulkOrderForm />
        </>
    );
};

export default Contact;